import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.faq.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import moment from "moment";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcadmin-faq-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.faq.item/view.scss */
/* src/app/portal.gsdcadmin.faq.item/view.scss: no such file or directory */`],
})
export class PortalGsdcadminFaqItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() faq_id: any;

    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;
    
    public info: any = {};
    public tags: any = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/");
        await this.load();
        await this.buildEditor();
        await this.service.loading.hide();
    }

    public async load() {
        if (this.faq_id != 'new') {
            const { code, data } = await wiz.call("get", { id: this.faq_id });
            if (code != 200) return await this.service.alert.error("Error!");
            this.info = data.item;
            this.tags = JSON.parse(this.info.tag.replace(/'/g, '"'));
            if (this.info.extra != null) this.info.extra = JSON.parse(this.info.extra.replace(/'/g, '"'));
        } else {
            this.info = {
                title: '',
                content: '',
                tags: [],
                extra: [],
                created: moment().format("YYYY-MM-DD")
            };
        }
        await this.service.render();
    }

    public async buildEditor() {
        // let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.info.content);
    }

    public async tagAdd(target) {
        if (this.tags) this.tags.push(target);
        else this.tags = [target];
        await this.service.render();
    }

    public async tagRemove(target) {
        this.tags = this.tags.filter(tag => tag !== target);
        await this.service.render();
    }

    public async update() {
        if (this.info.title == "") return await this.service.alert.error("제목을 입력해주세요.")
        else if (this.tags.length == 0) return await this.service.alert.error("태그를 선택해주세요.")

        this.info.content = this.editor.data.get();
        this.info.tag = this.tags;
        let data: any = JSON.stringify(this.info);
        let { code } = await wiz.call("update", { data: data });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("저장되었습니다.");
        this.router.navigateByUrl('/admin/faq');
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.info.id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.router.navigateByUrl('/admin/faq');
    }

    public async upload() {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();

        if (!this.info.extra) this.info.extra = [];

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            this.info.extra.push({ name: files[i].name, url: url });
        }

        await this.service.loading.hide();
        this.service.render();
    }

    public async removeFile(file) {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        this.info.extra.remove(file);
        this.service.render();
    }
}

export default PortalGsdcadminFaqItemComponent;